import React from 'react';

import {PartJSON} from 'biojs/Part';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import AttachDropdown from 'ui-library/attach-dropdown/AttachDropdown';
import {AttachDropdownItem} from 'ui-library/attach-dropdown/AttachDropdownConstants';
import {SelectAttachment} from 'ui-library/attach-dropdown/AttachDropdownOptionsMenu';
import {ElementKeyboardEvent} from 'util/Types';

export interface PartSearchDropdownProps {
  sequenceParts: Array<PartJSON>;
  query: string;
  tagSchemaId: string | null;
  selectAttachment: SelectAttachment;
}

class PartSearchDropdown extends React.Component<PartSearchDropdownProps, {}> {
  attachDropdownRef = React.createRef<AttachDropdown>();

  _matchSearch(part: PartJSON, query: string): boolean {
    return part.name!.toLowerCase().includes(query.toLowerCase());
  }

  _partToResult(part: PartJSON): AttachDropdownItem {
    return {
      name: part.name!,
      item_id: part.sequence!.id,
      item: part.sequence!,
      type: ModelTypeConstants.SEQUENCE,
    };
  }

  _getRecursiveParts(parts: Array<PartJSON>): Array<PartJSON> {
    const recursiveParts = [];
    for (const part of parts) {
      if (part.sequence) {
        recursiveParts.push(part);
        if (part.sequence.parts) {
          recursiveParts.push(...this._getRecursiveParts(part.sequence.parts));
        }
      }
    }
    return recursiveParts;
  }

  _getValidParts(sequenceParts: Array<PartJSON>): Array<PartJSON> {
    return (
      this._getRecursiveParts(sequenceParts)
        // Only include parts with name matching the query
        .filter((part) => part.sequence && this._matchSearch(part, this.props.query))
        // Only include parts that have the correct schema
        .filter((part) => part.sequence!.tagSchema && part.sequence!.tagSchema.id === this.props.tagSchemaId)
    );
  }

  queryKeydownHandler(e: ElementKeyboardEvent): boolean {
    if (!this.attachDropdownRef.current) {
      return false;
    }
    return this.attachDropdownRef.current.queryKeydownHandler(e);
  }

  render(): JSX.Element {
    const results = this._getValidParts(this.props.sequenceParts).map((part) => this._partToResult(part));
    return (
      <AttachDropdown
        ref={this.attachDropdownRef}
        emptyQueryMessage="No parts available for this field"
        errorMessage={null}
        results={results}
        searching={false}
        width="100%"
        {...this.props}
      />
    );
  }
}

export default PartSearchDropdown;
